import assertNever from "assert-never";
import HTMLReactParser, { domToReact, Element } from "html-react-parser";
import React from "react";
import ReactPlayer from "react-player";
import { API } from "../API";
import { PromoPopover } from "../messages";
import { getLocalStorageItem, setLocalStorageItem } from "../storage_utils";
import { AppVersion } from "../version";
import AgencyVideo from "./AgencyVideo";
import CaregiverSurveyActivity from "./CaregiverSurvey/CaregiverSurveyActivity";
import PassportVideo from "./PromoComponents/PassportVideo";

export interface PromoPopoverScreenProps {
  popover: PromoPopover;
  onClickClose: () => void;
  onClickPassport: (dontShowAgain: boolean) => void;
  onClickCaregiverSurvey: () => void;
  api: API;
}

let self: any;
type DOMNode = Comment | Element | Node | ProcessingInstruction | Text;

export class PromoPopoverScreen extends React.Component<PromoPopoverScreenProps> {
  constructor(props: PromoPopoverScreenProps) {
    super(props);
    self = this;
  }

  parseHtmlContent(htmlToParse: string) {
    return HTMLReactParser(htmlToParse, { replace: self.transform });
  }

  transform(node: DOMNode): Element | object | void | undefined | null | false {
    const popover = self.props.popover;
    const onClose = () => {
      self.props.onCloseClick();
      getLocalStorageItem(popover.localStorageKey).then((amountShown) => {
        setLocalStorageItem(
          popover.localStorageKey,
          amountShown === null ? "1" : "" + (+amountShown + 1)
        );
      });
    };

    if (!(node instanceof Element)) {
      return undefined;
    }

    if (node.attribs["data-close"] === "closeButton") {
      return <span onClick={onClose}>{domToReact([node], { replace: self.transform })}</span>;
    }

    if (node.name === "reactplayer") {
      const versionSplit = AppVersion.split(".");
      let url;
      // Version greater than 3.9.*
      if (parseInt(versionSplit[0], 10) >= 3 && parseInt(versionSplit[1], 10) >= 9) {
        url = node.attribs["youtubeurl"];
      } else {
        url = node.attribs["vimeourl"];
      }

      return (
        <ReactPlayer
          controls={node.attribs["controls"] as unknown as boolean}
          width={node.attribs["width"]}
          height={node.attribs["height"]}
          url={url}
        />
      );
    }

    return undefined;
  }

  renderPromoComponent(componentName: string) {
    switch (componentName) {
      case "passport-video":
        return (
          <PassportVideo
            onClickPassport={(dontShowAgain) => this.props.onClickPassport(dontShowAgain)}
          />
        );
      case "caregiver-survey": {
        const popover = self.props.popover;
        return (
          <CaregiverSurveyActivity
            api={this.props.api}
            onClickCaregiverSurvey={() => this.props.onClickCaregiverSurvey()}
            localStorageKey={popover.localStorageKey}
          />
        );
      }
      case "agency-video":
        return <AgencyVideo closeVideo={this.props.onClickClose} />;
      default:
        return null;
    }
  }

  render() {
    switch (this.props.popover.type) {
      case "COMPONENT":
        return this.renderPromoComponent(this.props.popover.component);
      case "HTML":
        return this.parseHtmlContent(this.props.popover.htmlContent);
      default:
        return assertNever(this.props.popover);
    }
  }
}
